import React from 'react';
import { Alert } from '@mui/material';
import StyledBox from 'views/rebranded-module/common/components/UI/NewMainWidget/NewWidgetAlert/NewWidgetAlert.styles';

const NewWidgetAlert = (props) => {
  const { alertMassage } = props;

  return (
    <StyledBox className="widgetAlert">
      <Alert severity="error">{alertMassage}</Alert>
    </StyledBox>
  );
};
export { NewWidgetAlert };
